import React from "react";
import { useLocation } from "react-router-dom";

//Scrolls to the top on page change, or to the #section when the link has one (e.g. /#gallery).
//The header menu scrolls the home page itself and passes state.noScroll, so it isn't done twice
const ScrollToTop = () => {
  const { pathname, hash, state } = useLocation();

  React.useEffect(() => {
    if (state && state.noScroll) {
      return undefined;
    }
    if (hash) {
      //Wait for the page to render the target
      const timeout = window.setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
      return () => window.clearTimeout(timeout);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    return undefined;
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
